"use strict";

import angular from "angular";
import _ from "lodash";

import Highcharts from "highcharts";
import Exporting from "highcharts/modules/exporting";
import moment from "moment";
import { DateHelper } from "../../presentation/services/DateHelper/DateHelper";
require("highcharts/highcharts-more")(Highcharts);

export class ChartStructure {
    constructor($filter, $mdMedia, $timeout, ChartHelper, ChartSeries) {
        Exporting(Highcharts);

        this.$filter = $filter;
        this.$mdMedia = $mdMedia;
        this.$timeout = $timeout;

        this.ChartHelper = ChartHelper;
        this.ChartSeries = ChartSeries;
    }

    periodLabels = (date, period) => {
        const year = moment(date).add(1, "month").format("YYYY");

        if (period == "quarterly") {
            const response = `${DateHelper.nameQuarterly(date, true)} ${year}`;

            return response;
        }

        if (period == "semester") {
            const response = `${DateHelper.nameSemester(date, true)} ${year}`;

            return response;
        }

        return year;
    };

    /**
     * @public
     *
     * @param {Object} date
     *
     */
    tooltipLabels = (date) => {
        const period = "monthly";

        if (["yearly", "quarterly", "semester"].includes(period)) {
            date = parseInt(date);

            return this.periodLabels(date, period);
        }

        return moment(date).add(1, "months").format("MMMM YYYY");
    };

    /**
     * @private
     *
     * @param {Array} categories
     */
    _xAxisConfig(categories) {
        let xAxis = _.get(this.optionsChart, "xAxis");

        const period = "monthly";

        if (["yearly", "quarterly", "semester"].includes(period) && !xAxis) {
            categories = categories.map((date) => {
                date = parseInt(date);

                return this.periodLabels(date);
            });

            xAxis = {
                categories
            };
        }

        xAxis = xAxis
            ? xAxis
            : {
                  type: "datetime",
                  labels: {},
                  min: parseInt(_.head(categories)),
                  max: parseInt(_.last(categories))
              };

        return xAxis;
    }

    /**
     * @private
     * Configura opções customizadas pelo category do gráfico se ele possuir
     * @param {Object} config Configuração do gráfico
     * @returns {Object} Nova configuração
     */
    _customConfig(config) {
        const types = {
            gauge: () => {
                config.pane = {
                    ...config.pane,
                    center: ["50%", "95%"],
                    size: this.$mdMedia("gt-sm") ? "150%" : "100%"
                };
            }
        };

        if (types[config.category]) types[config.category]();
        return config;
    }

    /**
     * @private
     *
     * @returns {Object} de configurações do gráfico
     */
    _structure() {
        if (!this.data) return;
        const _formatValue = this.ChartHelper.formatValue;

        const _formatLabel = this.tooltipLabels;

        let defaultSeries = _.get(this.optionsChart, "series") || [];

        const series = this.ChartSeries.format(
            this.data.series,
            this.data.points,
            this.data.dates,
            defaultSeries,
            this.chartCategory,
            "monthly",
            this.rewriteCategories
        );

        if (!series) return;

        const categories = this.ChartSeries.dates;

        if (this.title) {
            this.title = Object.assign(this.ChartSeries._getText(), this.title);
        }

        const options = {
            title: this.title
                ? this.title
                : {
                      text: ""
                  },

            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            },
            xAxis: this._xAxisConfig(categories),
            series,
            tooltip: _.get(this.optionsChart, "tooltip") || {
                formatter: function () {
                    if (this.series) {
                        const unit = _.get(this.series, "userOptions.unit");

                        //caso especial dos gráficos single
                        const key = _.get(this.series, "userOptions.key");

                        switch (
                            _.get(this.series, "chart.userOptions.category")
                        ) {
                            case "waterfall":
                                const percentage =
                                    (this.y /
                                        _.last(_.get(this.series, "yData"))) *
                                    100;

                                const fixed =
                                    percentage > 99 || percentage === 0
                                        ? false
                                        : true;

                                return `${this.key}: <br>
                            ${_formatValue("currency", this.y)} <br>
                            ${_formatValue("percentage", percentage, fixed)}`;

                            default:
                                return `${
                                    key ? this.key : this.series.name
                                } ${_formatValue(unit, this.y)}`;
                        }
                    }
                }
            }
        };

        const config = { ...this.optionsChart, ...options };
        const newConfig = this._customConfig(config);

        return newConfig;
    }

    /**
     * @public
     * Generate an unique id for the chart
     */
    getId = (id) => {
        return `${id}_${Date.now()}`;
    };

    /**
     * @public
     * Generate strucutre of the chart
     */
    structure = (_id, data, optionsChart, rewriteCategories = false) => {
        this.optionsChart = optionsChart;

        this.title = _.get(this.optionsChart, "title");

        this.chartCategory = _.get(this.optionsChart, "category");

        this.data = data;

        this.rewriteCategories = rewriteCategories;

        const structure = this._structure();

        if (!structure) return;

        return structure;
    };

    /**
     * @public
     * @param {String} _id
     */
    generate = (_id, data, optionsChart, rewriteCategories = false) => {
        const structure = this.structure(
            _id,
            data,
            optionsChart,
            (rewriteCategories = false)
        );
        return document.getElementById(_id)
            ? new Highcharts.Chart(_id, structure)
            : null;
    };
}

angular
    .module("nucont.shared")
    .service("ChartStructure", [
        "$filter",
        "$mdMedia",
        "$timeout",
        "ChartHelper",
        "ChartSeries",
        ChartStructure
    ]);
